import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import {
  CuestionarioSnapshotRequest,
  CuestionarioSnapshotResponse,
} from '../../models/cuestionario-snapshot/cuestionario-snapshot';

@Injectable({
  providedIn: 'root',
})
export class CuestionarioSaludSnapshotService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.CUESTIONARIO_SNAPSHOT}`;

  constructor(private http: HttpClient) {}

  guardarSnapshot(
    request: CuestionarioSnapshotRequest,
  ): Observable<CuestionarioSnapshotResponse> {
    return this.http.post<CuestionarioSnapshotResponse>(this.apiUrl, request);
  }
}
